import script from "./PayDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./PayDialog.vue?vue&type=script&lang=ts&setup=true"

import "./PayDialog.vue?vue&type=style&index=0&id=6ff9a426&lang=scss"
import "./PayDialog.vue?vue&type=style&index=1&id=6ff9a426&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Client_OdpJ/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ff9a426"]])

export default __exports__